var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown2Plain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97976 5.31312C3.15727 5.13561 3.43505 5.11947 3.63079 5.26471L3.68687 5.31312L7.99998 9.626L12.3131 5.31312C12.4906 5.13561 12.7684 5.11947 12.9641 5.26471L13.0202 5.31312C13.1977 5.49063 13.2138 5.76841 13.0686 5.96415L13.0202 6.02023L8.35353 10.6869C8.17602 10.8644 7.89825 10.8805 7.7025 10.7353L7.64643 10.6869L2.97976 6.02023C2.7845 5.82496 2.7845 5.50838 2.97976 5.31312Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2Plain);
export default __webpack_public_path__ + "static/media/arrow-down-2-plain.8c8cba51329223fd4787100143161468.svg";
export { ForwardRef as ReactComponent };